// import axios from "axios";
// import {Dispatch} from "redux";
import {ActionType} from "../action_type";
// import {Action} from "../actions/userInfoAction";

export const userLogin = () => {
  return async (dispatch: any) => {
    dispatch({
      type: ActionType.USERLOGIN
    })

    try {

    } catch (err : any) {
      dispatch({
        type: ActionType.USERLOGIN_ERROR,
        payload: err.message
      })
    }
  }
}

